import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Necesito creer en espiritualidad?',
    a: 'No. Combina psicología, neurociencia y finanzas personales. Los resultados llegan independientemente de tus creencias.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'En 5 minutos recibís un mail con descarga directa de los 3 PDFs y el audio MP3. Tuyo para siempre.'
  }, {
    q: '¿Funciona en Argentina?',
    a: 'Fue diseñado específicamente para Argentina. Incluye el Protocolo Anti-Devaluación Mental y herramientas que funcionan independientemente del dólar o la inflación.'
  }, {
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Cambios internos: primeros 7 días. Resultados financieros medibles: día 30. Transformación completa: 180 días.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si abrís los tomos y en 7 días sentís que no es lo que esperabas, escribís a soportelumenakasha@gmail.com y te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-52">
      <div className="text-center mb-12" data-id="element-53">
        <h2 className="md:text-4xl font-serif font-bold mb-4 flex items-center justify-center text-[22px]" data-id="element-54">
          <span className="mr-3" data-id="element-55">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-56">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-pink/30 bg-white/60" data-id="element-57">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/30 transition-colors" data-id="element-58">
              <span className="font-medium pr-8 text-brand-text text-[14px]" data-id="element-59">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-60" />
            </button>
            <AnimatePresence data-id="element-61">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-62">
                  <div className="px-6 pb-5 text-brand-text/70 border-t border-brand-pink/20 pt-4 bg-white/40 text-[12px]" data-id="element-63">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};